import {all, fork, put, takeEvery, call} from "redux-saga/effects";
import {SagaIterator} from "@redux-saga/core";


// actions
import updateAction, {updateRequest} from "./uiActions";

// constants
import {UIActionTypes} from "./constants";
import {get as getRequest} from "../../helpers/api/request";
import {chatroomDetail} from "../../helpers/api/chat";
import {getSocket} from "../../socket";
import {getUserFromCookie} from "../../helpers/api/apiCore";
import {toast} from "react-toastify";


function* getChatroomSaga(data: any): SagaIterator {

    try {
        yield put(updateAction({loader: true}));
        const chatroomId = data.payload.chatroomId
        // @ts-ignore
        const response = yield call(chatroomDetail, chatroomId);

        yield put(updateAction({selectedRoom: response?.data?.data}));

        console.log("test");
        const user = getUserFromCookie();
        const s = getSocket();
        s?.emit("join-room", {
            roomId: response?.data?.data.id,
            peerId: user.id,
            userName: user.name + " " + user.surname,
            peerType: "Agent",
            profilePicture: user?.avatar,
        });
        console.log("nasil ?");

    } catch (e: any) {

        if (!e.message) {
            toast.error(e);
        }
    } finally {
        yield put(updateAction({loader: false}));
    }
}


function* getRequestSaga(data: any): SagaIterator {

    try {
        yield put(updateAction({loader: true}));
        const requestId = data.payload.requestId
        // @ts-ignore
        const response = yield call(getRequest, requestId);


        yield put(updateRequest(response.data?.data));

    } catch (e: any) {
        console.log(e);
        if (!e.message) {
            toast.error(e);
            data.navigate("/dashboard");
        }
    } finally {
        yield put(updateAction({loader: false}));
    }
}


function* getAwaitingSupervisorList(data: any): SagaIterator {
    try {
        yield put(updateAction({loader: true}));
        // @ts-ignore
        const response = yield call(awaitingOfferPackages);
        yield put(updateAction({awaitingSupervisorList: response?.data?.data}));

    } catch (e: any) {
        console.log(e);
        if (!e.message) {
            toast.error(e);
        }
    } finally {
        yield put(updateAction({loader: false}));
    }
}

export function* watchGetRequest() {
    yield takeEvery(UIActionTypes.REQUEST, getRequestSaga);
    yield takeEvery(UIActionTypes.CHATROOM, getChatroomSaga);
    yield takeEvery(UIActionTypes.AWAITING_SUPERVISOR_OFFER_PACKAGES, getAwaitingSupervisorList);
}

function* uiSaga() {
    yield all([
        fork(watchGetRequest),
    ]);
}

export default uiSaga;
